import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import shouldOpenInCompose from './shouldOpenInCompose';

/**
 * If true, this calendar event is not a draft and exposes full details for viewing by the current user.
 * Otherwise it is a draft and/or only freebusy status is visible.
 */
export default function canRead(item: CalendarEvent): boolean {
    if (shouldOpenInCompose(item)) {
        return false;
    }
    return !!(item.EffectiveRights && item.EffectiveRights.Read);
}
